import React, { useRef } from "react";
import { Divider, Space } from "antd";
import { hooks, models } from "@vote4dance/judging-sdk";
var RoundPathSource = models.rounds.RoundPathSource;
var RoundItem = models.rounds.RoundItem;
var Stream = hooks.streams.Stream;
const roundPathCache = new Map();
export function useRoundPath(round) {
    var _a, _b;
    const cacheRef = useRef(roundPathCache);
    const roundKey = (round === null || round === void 0 ? void 0 : round.round_id) ? `${round.competition_id}-${round.round_id}` : '';
    const source = round && round.round_id && round.competition_id
        ? RoundPathSource(round.competition_id, round.round_id)
        : undefined;
    const cachedItem = roundKey ? cacheRef.current.get(roundKey) : undefined;
    const [paths, loading, error] = Stream(source);
    const resolvedPaths = paths !== null && paths !== void 0 ? paths : cachedItem === null || cachedItem === void 0 ? void 0 : cachedItem.paths;
    const pathString = resolvedPaths ? resolvedPaths.map(a => a.round_label).join(' - ') : (_a = cachedItem === null || cachedItem === void 0 ? void 0 : cachedItem.pathString) !== null && _a !== void 0 ? _a : '';
    const defaultElement = round ? (React.createElement(Space, { separator: React.createElement(Divider, { orientation: "vertical" }) }, RoundItem.getClassLabel(round))) : undefined;
    const element = round
        ? (_b = cachedItem === null || cachedItem === void 0 ? void 0 : cachedItem.element) !== null && _b !== void 0 ? _b : (resolvedPaths
            ? (React.createElement(Space, { separator: React.createElement(Divider, { orientation: "vertical" }) },
                RoundItem.getClassLabel(round),
                resolvedPaths.map((item, index) => (React.createElement("div", { key: index }, RoundItem.getRoundLabel(item))))))
            : defaultElement)
        : undefined;
    const effectiveLoading = loading && !cachedItem;
    React.useEffect(() => {
        if (!roundKey || !resolvedPaths) {
            return;
        }
        const newElement = (React.createElement(Space, { separator: React.createElement(Divider, { orientation: "vertical" }) },
            RoundItem.getClassLabel(round),
            resolvedPaths.map((item, index) => (React.createElement("div", { key: index }, RoundItem.getRoundLabel(item))))));
        cacheRef.current.set(roundKey, {
            paths: resolvedPaths,
            pathString,
            element: newElement
        });
    }, [roundKey, resolvedPaths, pathString, round]);
    return [
        pathString,
        resolvedPaths !== null && resolvedPaths !== void 0 ? resolvedPaths : [],
        element,
        effectiveLoading,
        error
    ];
}
